/* eslint-disable jsdoc/check-param-names */
import React from 'react';
import { registerBrick, BrickContext } from 'olympe';
import { ReactBrick, useProperty } from '@olympeio/core';
import { Typography } from '@mui/material';
import { Image } from './Image.jsx';

export default class HomeTile extends ReactBrick {
    /**
     * @override
     */
    updateParent(parent, element) {
        parent.style.overflow = 'visible'; // Allow overflow, so that shadow can be seen
        return super.updateParent(parent, element);
    }

    /**
     * Colored Tile that changes color while hovered
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!Array<*>} properties
     * @returns {Element}
     */
    static getReactComponent($) {
        return (props) => {
            const image = useProperty($, 'Image');
            const tileLabel = useProperty($, 'Label');
            const hidden = useProperty($, 'Hidden');
            const scaling = useProperty($, 'Scaling');

            return (
                !hidden && (
                    <div
                        className="home-tile-container"
                        onClick={() => {
                            $.trigger('On Click');
                        }}
                    >
                        <Image
                            imageFile={image}
                            style={{
                                width: `${scaling * 98}px`,
                                height: `${scaling * 98}px`,
                            }}
                        />
                        <Typography
                            style={{
                                color: 'white',
                                fontSize: `${scaling * 42}px`,
                                paddingLeft: `${scaling * 44}px`,
                            }}
                        >
                            {tileLabel}
                        </Typography>
                    </div>
                )
            );
        };
    }
}

registerBrick('0184d1d2abad2d97f21d', HomeTile);
